import type { ReactNode, JSX } from "react";

import { cn } from "@repo/cn";

interface RoundedLayoutProps {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
}

export const RoundedLayout = ({
  children,
  className,
  contentClassName,
}: RoundedLayoutProps): JSX.Element => (
  <div
    className={cn(
      "flex flex-1 flex-col overflow-hidden bg-primary-400 md:bg-white pt-[5px]",
      className,
    )}
  >
    <div
      className={cn(
        "flex flex-1 flex-col overflow-hidden md:overflow-y-auto rounded-t-2xl bg-white",
        contentClassName,
      )}
    >
      {children}
    </div>
  </div>
);
